var OpenTypeParser = /** @class */ (function () {
    function OpenTypeParser() {
    }
    OpenTypeParser.parseData = function (tag) {
        var opentype = OpenTypeParser.openType;
        if (!opentype)
            console.error('[OpenTypeParser] - opentype.js is not registered');
        var font = opentype.parse(tag.data.buffer);
        return font;
    };
    return OpenTypeParser;
}());
export { OpenTypeParser };
